import { ArchiveState } from '../models/archive.model';

const initialArchiveState: ArchiveState = {
    archiveList: {},
    deleteArchivedData: {},
    searchList: {},
    hierarchicalData: {},
    dataToBeRestored: {},
    restoreData: {}
};
export default initialArchiveState;
